import { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import axios from "axios";
import moment from "moment";

import { BottomsheetDropdown } from "components";
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID, MOBILE_NO_VALIDATION, PAN_NUMBER_REGEX } from "constants/Constants";
import * as APITypes from "../../../../../../constants/API";
import './is-existing-customer-modal-fgs.css'
import CustomizationLoader from "components/ui/customization-loader/CustomizationLoader";
import getCookie from "utils/journeyIdCookie/getJourneyId";

const IsExistingCustomerModalForFGS = (props) => {
    const { formRef, show, onHide, productData } = props

    const [searchType, setSearchType] = useState({ id: "customer_id", label: "Customer ID" })
    const [searchValue, setSearchValue] = useState({ value: "", errorMessage: "" })
    const [dobValue, setDobValue] = useState({ value: "", errorMessage: "", showDOB: false })
    const [IsExistingCustomer, setIsExistingCustomer] = useState({ status: false, message: "" })
    const [existingCustomerBenefit, setExistingCustomerBenefit] = useState({ id: true, label: "Yes" },)
    const [familyBenefit, setFamilyBenefit] = useState({ id: false, label: "No" },)
    const [relationShip, setRelationShip] = useState({ value: {}, errorMessage: "" })
    const [firstName, setFirstName] = useState({ value: "", errorMessage: "" })
    const [middleName, setMiddleName] = useState({ value: "", errorMessage: "" })
    const [lastName, setLastName] = useState({ value: "", errorMessage: "" })
    const [loading, setLoading] = useState(false)
    const optionList = [
        { id: "customer_id", label: "Customer ID" },
        { id: "mobile_number", label: "Mobile Number" },
        { id: "pan_number", label: "Pan Number" },
        { id: "policy_number", label: "Policy Number" }
    ]

    const existingCustomerBenefitList = [
        { id: true, label: "Yes" },
        { id: false, label: "No" },
    ]
    const familyBenefitList = [
        { id: true, label: "Yes" },
        { id: false, label: "No" },
    ]

    const relationShipList = [
        { id: 144, label: "Father" },
        { id: 145, label: "Mother" },
        { id: 146, label: "Spouse" },
        { id: 1367, label: "Brother" },
        { id: 1378, label: "Sister" },
        { id: 1962, label: "Son" },
        { id: 1963, label: "Daughter" },
        { id: 2150, label: "Spouse's Father" },
        { id: 2151, label: "Spouse's Mother" },
        { id: 2152, label: "Spouse's Brother" },
        { id: 2153, label: "Spouse's Sister" },
    ];

    useEffect(() => {
        let searchByKey = productData?.bi_request?.search_key
        let searchByValue = productData?.bi_request?.search_value
        let laDate = productData?.bi_request?.LI_DOB
        if (searchByKey) {
            let value = optionList?.find((item) => item?.id === searchByKey)
            setSearchType(value)
            setSearchValue({ value: searchByValue, errorMessage: "" })
            if (searchByKey === "mobile_number" || searchByKey === "policy_number") {
                let formattedDate = moment(laDate, "DD MMM YYYY")?.format("YYYY-MM-DD");
                setDobValue({ value: formattedDate, errorMessage: "", showDOB: true })
            } else {
                setDobValue({ value: "", errorMessage: "", showDOB: false })
            }
        }
    }, [])

    const onSearchTypeChanges = (searchTypeValue) => {
        if ((searchTypeValue.id === "mobile_number" || searchTypeValue?.id === "policy_number") || (familyBenefit?.id && searchTypeValue?.id === "customer_id")) {
            setDobValue({ value: "", errorMessage: "", showDOB: true })
        } else {
            setDobValue({ value: "", errorMessage: "", showDOB: false })
        }
        setSearchValue({ value: "", errorMessage: "" })
        setIsExistingCustomer({ value: false, message: '' })
    }
    const onClose = () => {
        onHide(IsExistingCustomer?.status)
    }

    const validation = (currentValue) => {
        setIsExistingCustomer({ value: false, message: '' })
        switch (searchType?.id) {

            case "mobile_number": // ! FOR MOBILE NO VALIDATION
                const mobileNoValue = currentValue?.replace(/[^0-9 ]/g, "")
                if (MOBILE_NO_VALIDATION.test(mobileNoValue || currentValue === "")) {
                    setSearchValue(prevState => ({ ...prevState, value: currentValue, errorMessage: "" }))
                } else {
                    setSearchValue(prevState => ({ ...prevState, value: currentValue, errorMessage: "Please enter a valid Mobile Number" }))
                }
                if (currentValue.length > 10) {
                    const value = currentValue.slice(0, 10)
                    setSearchValue(prevState => ({ ...prevState, value: value }))
                }
                break

            case "customer_id":
                setSearchValue(prevState => ({ ...prevState, value: currentValue }))
                break

            case "policy_number":
                setSearchValue(prevState => ({ ...prevState, value: currentValue }))
                break

            case "pan_number": // ! FOR PAN NO VALIDATION                
                if ((PAN_NUMBER_REGEX.test(currentValue)) || currentValue === "") {
                    setSearchValue(prevState => ({ ...prevState, value: currentValue, errorMessage: "" }))
                } else {
                    setSearchValue(prevState => ({ ...prevState, value: currentValue, errorMessage: "Please enter a valid Pan Number" }))
                }
                if (currentValue.length > 10) {
                    const value = currentValue.slice(0, 10)
                    setSearchValue(prevState => ({ ...prevState, value: value }))
                }
                break;

            default:
                break;
        }
    }

    const validateData = async () => {
        let isValid = false
        if (dobValue?.showDOB && !dobValue?.value) {
            setDobValue(prevState => ({ ...prevState, errorMessage: "This field is mandatory" }))
        }
        if (familyBenefit?.id) {
            if (!relationShip?.value) {
                setRelationShip(prevState => ({ ...prevState, errorMessage: "This field is mandatory" }))
                isValid = true
            }
            if (!firstName?.value) {
                setFirstName(prevState => ({ ...prevState, errorMessage: "This field is mandatory" }))
                isValid = true
            }
            if (!lastName?.value) {
                setLastName(prevState => ({ ...prevState, errorMessage: "This field is mandatory" }))
                isValid = true
            }
        }
        if (!searchValue?.value) {
            setSearchValue(prevState => ({ ...prevState, errorMessage: "This field is mandatory" }))
            return
        }
        if ((searchValue?.value && dobValue?.showDOB && !dobValue?.value) || isValid) {
            return
        }

        let requestObj = {
            "isFamilyMemberBenefit": familyBenefit?.id,
            "isExistingCustBenefit": existingCustomerBenefit?.id,
            "relationship_type": relationShip?.value?.id ? relationShip?.value?.id : "",
            "firstName": firstName?.value,
            "middleName": middleName?.value,
            "lastName": lastName?.value,
            "search_key": searchType?.id,
            "search_value": searchValue?.value,
            "dob": dobValue?.value ? dobValue?.value : "",
            "family_product_id": productData?.family_product_id,
            "journey_id": getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)
        }
        setLoading(true)

        const response = await axios.post(APITypes.VALIDATE_EXISTING_FAMILY_CUSTOMER, requestObj);
        if (response?.data) {
            setIsExistingCustomer({ status: response?.data?.isExistingCustomer ? true : false, message: response?.data?.message ? response?.data?.message : "data not found " })
        }
        setLoading(false)
    }
    const onFamilyBenefit = (value) => {
        if (value?.id) {
            setExistingCustomerBenefit({ id: false, label: "No" })
            setDobValue({ value: "", errorMessage: "", showDOB: true })
        } else {
            setExistingCustomerBenefit({ id: true, label: "Yes" })
            setDobValue({ value: "", errorMessage: "", showDOB: false })
        }
        setSearchType({ id: "customer_id", label: "Customer ID" })
        setSearchValue({ value: "", errorMessage: "" })
        // setDobValue({ value: "", errorMessage: "" })
        setRelationShip({ value: "", errorMessage: "" })
        setFirstName({ value: "", errorMessage: "" })
        setMiddleName({ value: "", errorMessage: "" })
        setLastName({ value: "", errorMessage: "" })


    }
    const onExitingBenefit = (value) => {
        if (value?.id) {
            setFamilyBenefit({ id: false, label: "No" })
            setDobValue({ value: "", errorMessage: "", showDOB: false })
        } else {
            setFamilyBenefit({ id: true, label: "Yes" })
            setDobValue({ value: "", errorMessage: "", showDOB: true })
        }
        setSearchType({ id: "customer_id", label: "Customer ID" })
        setSearchValue({ value: "", errorMessage: "" })
        // setDobValue({ value: "", errorMessage: "" })
        setRelationShip({ value: "", errorMessage: "" })
        setFirstName({ value: "", errorMessage: "" })
        setMiddleName({ value: "", errorMessage: "" })
        setLastName({ value: "", errorMessage: "" })
    }

    return (
        <>
            <div>
                <Modal
                    size="lg"
                    className="save-session-modal fund-distribution-modal"
                    show={show}
                    centered
                    keyboard={false}
                    onHide={onClose}
                >
                    <Modal.Header closeButton className="border-0 fund-distribution-modal-padding">
                        <Modal.Title className="font-size-16 text-header-style">
                            <div className="font-weight-normal text-primary">
                                <strong>Validate Existing Customer/Family Of Existing Customer Benefit</strong>
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="is-existing-cusstomer-fdp-body border-0">

                        <div className='row mt-2 mb-4'>
                            <div className='col-lg-6 col-12'>
                                <div className='row'>
                                    <div className='col-12'>
                                        <p className='pre-need-modal-label font-weight-medium'>Eligible For Existing Customer Benefit</p>
                                    </div>
                                </div>
                                <BottomsheetDropdown
                                    dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    menuItemStyle='d-flex justify-content-between align-items-center'
                                    menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    selectedLabelKey='label'
                                    bottomsheetTitle={"Select an Option"}
                                    menuList={existingCustomerBenefitList}
                                    value={existingCustomerBenefit}
                                    // showErrorMsg={formController.$("existing_customer_type_option_list").error !== null}
                                    // errorMsg={formController.$("existing_customer_type_option_list").error}
                                    onSelect={(e) => {
                                        setExistingCustomerBenefit(e)
                                        onExitingBenefit(e)

                                    }}
                                    disabled={false}
                                />
                            </div>
                            <div className='col-lg-6 col-12'>
                                <div className='row'>
                                    <div className='col-12'>
                                        <p className='pre-need-modal-label font-weight-medium'>Eligible For Family Of Existing Customer Benefit</p>
                                    </div>
                                </div>
                                <BottomsheetDropdown
                                    dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    menuItemStyle='d-flex justify-content-between align-items-center'
                                    menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    selectedLabelKey='label'
                                    bottomsheetTitle={"Select an Option"}
                                    menuList={familyBenefitList}
                                    value={familyBenefit}
                                    // showErrorMsg={formController.$("existing_customer_type_option_list").error !== null}
                                    // errorMsg={formController.$("existing_customer_type_option_list").error}
                                    onSelect={(e) => {
                                        setFamilyBenefit(e)
                                        onFamilyBenefit(e)
                                    }}
                                    disabled={false}
                                />
                            </div>
                        </div>
                        {familyBenefit?.id &&
                            <>
                                <div className='row mt-2'>
                                    <div className='col-12'>
                                        <div className='row'>
                                            <div className='col-12'>
                                                <p className='pre-need-modal-label font-weight-medium'> Family Benefit Customer Relation with Life Insured</p>
                                            </div>
                                        </div>
                                        <BottomsheetDropdown
                                            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                                            menuItemStyle='d-flex justify-content-between align-items-center'
                                            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                                            selectedLabelKey='label'
                                            bottomsheetTitle={"Select an Option"}
                                            menuList={relationShipList}
                                            value={relationShip?.value}
                                            // showErrorMsg={formController.$("existing_customer_type_option_list").error !== null}
                                            // errorMsg={formController.$("existing_customer_type_option_list").error}
                                            onSelect={(e) => {
                                                setRelationShip({ value: e, errorMessage: "" })
                                            }}
                                            disabled={false}
                                        />
                                        {relationShip?.errorMessage ? (
                                            <p className='font-size-12 font-weight-light text-danger mb-0'>{relationShip?.errorMessage}</p>
                                        ) : null}
                                    </div>
                                </div>

                                <div className="row mt-2">
                                    <div className='col-lg-4 col-12 '>
                                        <div className='row mt-2 mt-lg-0'>
                                            <div className='col-12'>
                                                <p className='pre-need-modal-label font-weight-medium'>First Name</p>
                                            </div>
                                        </div>
                                        <Form.Group className='mb-0'>
                                            <Form.Control
                                                type={"text"}
                                                className='font-size-lg-12 font-size-14 font-weight-light'
                                                placeholder={`Enter First Name`}
                                                value={firstName?.value}
                                                onChange={(e) => { setFirstName({ value: e?.target?.value, errorMessage: "" }) }}
                                                style={firstName?.errorMessage ? { border: "1px solid red" } : { border: "1px solid grey" }}
                                            />
                                            {firstName?.errorMessage ? (
                                                <p className='font-size-12 font-weight-light text-danger mb-0'>{firstName?.errorMessage}</p>
                                            ) : null}
                                        </Form.Group>
                                    </div>
                                    <div className='col-lg-4 col-12 '>
                                        <div className='row mt-2 mt-lg-0'>
                                            <div className='col-12'>
                                                <p className='pre-need-modal-label font-weight-medium'>Middle Name</p>
                                            </div>
                                        </div>
                                        <Form.Group className='mb-0'>
                                            <Form.Control
                                                type={"text"}
                                                className='font-size-lg-12 font-size-14 font-weight-light'
                                                placeholder={`Enter middle Name`}
                                                value={middleName?.value}
                                                onChange={(e) => { setMiddleName({ value: e?.target?.value, errorMessage: "" }) }}
                                                style={middleName?.errorMessage ? { border: "1px solid red" } : { border: "1px solid grey" }}
                                            />
                                            {middleName?.errorMessage ? (
                                                <p className='font-size-12 font-weight-light text-danger mb-0'>{middleName?.errorMessage}</p>
                                            ) : null}
                                        </Form.Group>
                                    </div>
                                    <div className='col-lg-4 col-12 '>
                                        <div className='row mt-2 mt-lg-0'>
                                            <div className='col-12'>
                                                <p className='pre-need-modal-label font-weight-medium'>Last Name</p>
                                            </div>
                                        </div>
                                        <Form.Group className='mb-0'>
                                            <Form.Control
                                                type={"text"}
                                                className='font-size-lg-12 font-size-14 font-weight-light'
                                                placeholder={`Enter last Name`}
                                                value={lastName?.value}
                                                onChange={(e) => { setLastName({ value: e?.target?.value, errorMessage: "" }) }}
                                                style={lastName?.errorMessage ? { border: "1px solid red" } : { border: "1px solid grey" }}
                                            />
                                            {lastName?.errorMessage ? (
                                                <p className='font-size-12 font-weight-light text-danger mb-0'>{lastName?.errorMessage}</p>
                                            ) : null}
                                        </Form.Group>
                                    </div>
                                </div>
                            </>}
                        <div className='row mt-2'>
                            <div className='col-lg-6 col-12'>
                                <div className='row'>
                                    <div className='col-12'>
                                        <p className='pre-need-modal-label font-weight-medium'>Search By</p>
                                    </div>
                                </div>
                                <BottomsheetDropdown
                                    dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    menuItemStyle='d-flex justify-content-between align-items-center'
                                    menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    selectedLabelKey='label'
                                    bottomsheetTitle={"Select an Option"}
                                    menuList={optionList}
                                    value={searchType}
                                    // showErrorMsg={formController.$("existing_customer_type_option_list").error !== null}
                                    // errorMsg={formController.$("existing_customer_type_option_list").error}
                                    onSelect={(e) => {
                                        setSearchType(e),
                                            onSearchTypeChanges(e)

                                    }}
                                    disabled={false}
                                />
                            </div>

                            <div className='col-lg-6 col-12 '>
                                <div className='row mt-2 mt-lg-0'>
                                    <div className='col-12'>
                                        <p className='pre-need-modal-label font-weight-medium'>{searchType?.label}</p>
                                    </div>
                                </div>
                                <Form.Group className='mb-0'>
                                    <Form.Control
                                        type={searchType.id === "mobile_number" ? "number" : "text"}
                                        className='font-size-lg-12 font-size-14 font-weight-light'
                                        placeholder={`Enter ${searchType?.label}`}
                                        value={searchValue?.value}
                                        onChange={(e) => { validation(e?.target?.value) }}
                                        style={searchValue?.errorMessage ? { border: "1px solid red" } : { border: "1px solid grey" }}
                                    />
                                    {searchValue?.errorMessage ? (
                                        <p className='font-size-12 font-weight-light text-danger mb-0'>{searchValue?.errorMessage}</p>
                                    ) : null}
                                </Form.Group>
                            </div>
                            {dobValue?.showDOB &&
                                <>
                                    <div className='col-lg-6 col-12'> </div>
                                    <div className='col-lg-6 col-12 mt-1 '>
                                        <div className='row'>
                                            <div className='col-12'>
                                                <p className='pre-need-modal-label font-weight-medium'>Date Of Birth</p>
                                            </div>
                                        </div>
                                        <input
                                            type="date"
                                            id="dob"
                                            name="dob"
                                            className={`w-100 pre-need-dob ${dobValue?.errorMessage ? 'pre-need-dob-error' : ''}`}
                                            value={dobValue?.value}
                                            onChange={(e) => {
                                                const value = e?.target?.value;
                                                const date = new Date(value);
                                                const isValid = !isNaN(date?.getTime());
                                                if (value.length === 10 && isValid) {
                                                    setDobValue(prevState => ({ ...prevState, errorMessage: "", value }));
                                                } else {
                                                    setDobValue(prevState => ({ ...prevState, errorMessage: "Invalid date", value: "" }));
                                                }
                                            }}
                                            max={moment().subtract(18, 'years').format('YYYY-MM-DD')}
                                        />
                                        {dobValue?.errorMessage ? (
                                            <p className='font-size-12 font-weight-light text-danger mb-0'>{dobValue?.errorMessage}</p>
                                        ) : null}
                                    </div>
                                </>
                            }
                            {IsExistingCustomer?.message && <p className={`mt-4 mx-3 ${IsExistingCustomer?.status ? 'text-success' : 'text-danger'}`}>{IsExistingCustomer?.message}</p>}
                            {loading &&
                                <div className="d-flex justify-content-center w-100 mt-3">
                                    <CustomizationLoader />
                                </div>
                            }

                            {!IsExistingCustomer?.message &&
                                <div className="text-center w-100">
                                    <button type="button" onClick={() => validateData()} class="btn btn-secondary btn-lg modal-cta-btn py-2 py-lg-1 mt-2 mb-2 mb-lg-0 font-size-14 font-size-lg-13 font-weight-medium w-25 mt-3">Validate</button>
                                </div>
                            }
                            {IsExistingCustomer?.message &&
                                <div className="text-center w-100">
                                    <button type="button" onClick={() => onClose()} class="btn btn-secondary btn-lg modal-cta-btn py-2 py-lg-1 mt-2 mb-2 mb-lg-0 font-size-14 font-size-lg-13 font-weight-medium w-25 mt-3">Close</button>
                                </div>
                            }

                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </>
    )

}
export default IsExistingCustomerModalForFGS;